import classNames from 'classnames';
import { ClassNameType } from 'interfaces';

const styles = {
  component: (className: ClassNameType) => (classNames(
    'md:flex',
    '!my-8',
    className,
  )),
  buttonContainer: (isLast: boolean = false) => (classNames(
    'flex',
    'items-center',
    {
      '!w-full': !isLast,
      '!w-auto': isLast,
    },
  )),

};

export default styles;
